import { SeeqNames } from '@seeqdev/constants';

const packageName = SeeqNames.MlService.PlsRegression.Connection.UdfPackage;
const udfName = SeeqNames.MlService.PlsRegression.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_COMPONENTS = 2;
export const VALIDATION_ERROR_DELAY = 500;
export const DEFAULT_SCALE = true;
export const DEFAULT_TOLERANCE = 1e-6;
export const DEFAULT_MAX_ITERATIONS = 500;
export const MAX_INPUT_SIGNALS = 50;

export const INPUT_NAMES = {
  targetSignalInput: 'targetSignalInput',
  nComponentsInput: 'nComponentsInput',
  scaleInput: 'scaleInput',
  maxIterationsInput: 'maxIterationsInput',
  toleranceInput: 'toleranceInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalNameInput: 'signalNameInput',
  rSquaredNameInput: 'rSquaredNameInput',
  modelInputPropNameInput: 'modelInputPropNameInput',
  modelTrainingWindowConditionNameInput: 'modelTrainingWindowConditionNameInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, Record<string, string>> = {
  predictionOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.PREDICTION',
    icon: 'fc fc-series',
  },
  rSquaredOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.R_SQUARED',
    icon: 'fc fc-scalar',
  },
  xWeightsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.X_WEIGHTS',
    icon: 'fc fc-scalar',
  },
  yWeightsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.Y_WEIGHTS',
    icon: 'fc fc-scalar',
  },
  xLoadingsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.X_LOADINGS',
    icon: 'fc fc-scalar',
  },
  yLoadingsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.Y_LOADINGS',
    icon: 'fc fc-scalar',
  },
  coefficientsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.COEFFICIENTS',
    icon: 'fc fc-scalar',
  },
  interceptOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.INTERCEPT',
    icon: 'fc fc-scalar',
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: 'fc fc-scalar',
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: 'fc fc-capsule-set',
  },
};

export const DEFAULT_OUTPUTS: string[] = ['predictionOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.PartialLeastSquares;
